var map = {
	"./pl": 148,
	"./pl.js": 148
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 300;



//////////////////
// WEBPACK FOOTER
// ./~/moment/locale pl
// module id = 300
// module chunks = 0